<template>
  <div>
    <com-search :columns="searchColumn" @search="handleSearch">
      <el-button v-if="!typeOfView" type="primary" @click="handleExport">导出</el-button>
    </com-search>
  </div>
</template>

<script>
export default {
  props: {
    typeOfView: {
      type: String,
      default: ''
    }
  },
  watch: {
    typeOfView: {
      handler(val) {
        if (val === 'partner' || val === 'shop') {
          this.searchColumn.splice(3, 2)
        }
        if (val === 'user') {
          this.searchColumn.splice(1, 4)
          const newItem = {
            label: '充值时间',
            prop: 'date',
            type: 'date'
          }
          this.searchColumn.splice(1, 0, newItem)
        }
        if (val === 'site') {
          this.searchColumn = [
            {
              label: '订单号',
              prop: 'number',
              type: 'input'
            },
            {
              label: '设备号',
              prop: 'refDevSn',
              type: 'input'
            },
            {
              label: '二维码',
              prop: 'refDevLabel',
              type: 'input'
            },
            {
              label: '订单状态',
              prop: 'status',
              type: 'select',
              option: [
                {
                  label: '全部',
                  value: null
                },
                {
                  label: '进行中',
                  value: 2
                },
                {
                  label: '已完成',
                  value: 3
                }
              ]
            }
          ]
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      searchColumn: [
        {
          label: '订单号',
          prop: 'number',
          type: 'input'
        },
        {
          label: '设备号',
          prop: 'refDevSn',
          type: 'input'
        },
        {
          label: '网点名称',
          prop: 'refStoreName',
          type: 'input'
        },
        {
          label: 'ID/手机号',
          prop: 'userCondition',
          type: 'input'
        },
        {
          label: '支付方式',
          prop: 'type',
          type: 'select',
          option: [
            {
              label: '钱包支付',
              value: '1'
            },
            {
              label: '套餐卡支付',
              value: '2'
            },
            {
              label: '微信支付',
              value: '3'
            }
          ]
        },
        {
          label: '设备二维码',
          prop: 'refDevLabel',
          type: 'input'
        }
      ]
    }
  },
  methods: {
    handleSearch(val) {
      console.log('handleSearch11111 :>> ', val)
      val.startTime = val.beginTime
      delete val.beginTime
      this.$emit('search', val)
    },
    handleExport() {
      this.$emit('onExport')
    }
  }
}
</script>
